import React, { useState, useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

// import {
//   auth,
//   signInWithEmailAndPassword,
//   sendPasswordResetEmail,
//   createUserWithEmailAndPassword,
//   setDoc,
//   doc,
//   db,
//   addDoc,
//   collection,
//   signOut,
//   onAuthStateChanged,
//   query,
//   where,
//   onSnapshot,
// } from '/Users/adityarouniyar/Desktop/convoai/src/firebase/config.js';

import Logo from '../components/common/Logo';
import DashboardNavItem from '../components/dashboard/DashboardNavItem';
import AgentDashboard from '../components/dashboard/AgentDashboard';
import AgentBuilder from '../components/dashboard/AgentBuilder';
import KnowledgeBase from '../components/dashboard/KnowledgeBase';
import ProfilePage from '../components/dashboard/ProfilePage';

const DashboardPage = ({ setPage }) => {
    const { user } = useAuth();
    const [activeTab, setActiveTab] = useState('dashboard');
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        if (user) {
            const unsub = onSnapshot(
                doc(db, "users", user.uid), 
                (doc) => {
                    if (doc.exists()) {
                        setUserData(doc.data());
                    } else {
                        console.log("No user document found");
                        setUserData(null);
                    }
                }, 
                (error) => {
                    console.error("Error fetching user data: ", error);
                    setUserData(null);
                }
            );
            return () => unsub();
        } else {
            setUserData(null);
        }
    }, [user]);

    const renderContent = () => {
        switch (activeTab) {
            case 'dashboard': return <AgentDashboard setActiveTab={setActiveTab} />;
            case 'createAgent': return <AgentBuilder setActiveTab={setActiveTab} />;
            case 'knowledgeBase': return <KnowledgeBase />;
            case 'profile': return <ProfilePage userData={userData} />;
            default: return <AgentDashboard setActiveTab={setActiveTab} />;
        }
    };

    return (
        <div className="flex min-h-screen bg-gray-100">
            {/* Sidebar */}
            <aside className="w-64 bg-white shadow-md flex flex-col p-4">
                <div
                    onClick={() => setPage('home')}
                    className="mb-8 cursor-pointer flex items-center"
                >
                    <Logo className="w-8 h-8" />

                </div>

                <nav className="flex-grow">
                    <ul>
                        <DashboardNavItem icon="M3.75 3v11.25A2.25 2.25 0 006 16.5h12A2.25 2.25 0 0020.25 14.25V3.75A2.25 2.25 0 0018 1.5H6A2.25 2.25 0 003.75 3zM12 7.5h6M12 11.25h6M3.75 8.25v5.25" label="Dashboard" tabName="dashboard" activeTab={activeTab} setActiveTab={setActiveTab} />
                        <DashboardNavItem icon="M12 4.5v15m7.5-7.5h-15" label="Create Agent" tabName="createAgent" activeTab={activeTab} setActiveTab={setActiveTab} />
                        <DashboardNavItem icon="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6-2.292m0 0v14.25" label="Knowledge Base" tabName="knowledgeBase" activeTab={activeTab} setActiveTab={setActiveTab} />
                        <DashboardNavItem icon="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" label="Profile" tabName="profile" activeTab={activeTab} setActiveTab={setActiveTab} />
                    </ul>
                </nav>
                
                {/* Back to Home Button */}
                <button
                                            className="mt-4 mb-2 w-full py-2 px-4 bg-[#B67BF4] hover:bg-[#7B34BB] rounded text-white font-semibold transition"
                    onClick={() => setPage('home')}
                >
                    &larr; Back to Home
                </button>

                <div className="text-center text-sm text-gray-500">
                    <p>&copy; 2025 ConvoAI</p>
                </div>
            </aside>

            {/* Main Content */}
            <main className="flex-1 p-8">
                {renderContent()}
            </main>
        </div>
    );
};

// export default DashboardPage;
//     );
// };

export default DashboardPage;

